export default __webpack_public_path__ + "static/media/no-video.2b4e51f8.svg";